export const USER_DATA = 'USER_DATA'
export const GLOBAL_CHAT = 'GLOBAL_CHAT'
export const CURRENT_SONG = 'CURRENT_SONG'
export const CURRENT_TIME = 'CURRENT_TIME'
export const IS_PAUSED = 'IS_PAUSED'
export const SITE_SETTINGS = 'SITE_SETTINGS'
export const LOAD_ALL_SONGS = 'LOAD_ALL_SONGS'